import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { GenericLabelValue } from "src/app/shared/models/DTO/GenericLabelValue.dto";
import { GenericStatus } from "src/app/shared/models/enums/GenericStatus.enum";
import { IntegratorRequest } from "src/app/shared/models/IntegratorRequest.model";

@Component({
	selector: "app-integration-ubereats-request-list",
	templateUrl: "./integration-ubereats-request-list.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class IntegrationUbereatsRequestListComponent implements OnInit {
	uberMenuSyncRequest: IntegratorRequest[];

	statusValues: GenericLabelValue[] = [
		{ label: "Pending", value: "Pending" },
		{ label: "Queued", value: "Queued" },
		{ label: "Submitted", value: "Submitted" },
		{ label: "Success", value: "Success" },
		{ label: "Failed", value: "Failed" },
		{ label: "Cancelled", value: "Cancelled" },
	];

	constructor(public app: AppService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		if (this.venueService.integratorRequestList.value.length === 0) {
			this.venueService.integratorRequestListGet();
		}
		this.venueService.integratorRequestList.subscribe((data) => {
			this.uberMenuSyncRequest = data.filter((x) => x.integrator === "uberEats");
			this.uberMenuSyncRequest.forEach((request) => {
				switch (request.status) {
					case GenericStatus.CANCELLED:
						request.status = "Cancelled";
						break;
					case GenericStatus.FAILED:
						request.status = "Failed";
						break;
					case GenericStatus.PENDING:
						request.status = "Pending";
						break;
					case GenericStatus.SUCCESS:
						request.status = "Success";
						break;
					case GenericStatus.SUBMITTEDTOINTEGRATOR:
						request.status = "Submitted";
						break;
					case GenericStatus.QUEUED:
						request.status = "Queued";
						break;
					default:
						request.status = "Unknown";
						break;
				}
			});
		});
	}
}
